import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WdpjService {

    evnetBus: Subject<string> = new Subject<string>();

    constructor() { }
}
